export const enum Environment {
  PRODUCTION,
  DEVELOPMENT,
  STAGING,
  DUKE_NUKEM
}

export function getEnvironment() : Environment {
  switch (window.bobw_houston?.env) {
    case 'prod': {
      return Environment.PRODUCTION;
    }

    case 'development': {
      return Environment.DEVELOPMENT;
    }

    case 'stage': {
      return Environment.STAGING;
    }

    case 'dukenukem': {
      return Environment.DUKE_NUKEM;
    }

    default: {
      return Environment.DEVELOPMENT;
    }
  }
}

export const getApiHost = () => {
  const apiHost = window.bobw_houston?.apiHost;

  return apiHost === '' ? 'http://localhost:3030' : apiHost;
};
